import { render, staticRenderFns } from "./TransferCenterTransfers.vue?vue&type=template&id=4906e8e1&scoped=true"
import script from "./TransferCenterTransfers.vue?vue&type=script&lang=js"
export * from "./TransferCenterTransfers.vue?vue&type=script&lang=js"
import style0 from "./TransferCenterTransfers.vue?vue&type=style&index=0&id=4906e8e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4906e8e1",
  null
  
)

export default component.exports